module.exports = __webpack_public_path__ + "704296a1703d25d7285a8025b4cf7e7b.ttf";